import { ReactElement } from 'react';
import FormGroup from '~/components/form/FormGroup';
import ValibotFieldCheckbox from '~/components/valibot/ValibotFieldCheckbox';
import {
  bre_is_aerial_photo,
  bre_is_aerial_video,
  BreAerialType,
} from '~/tenants/bre/performable/aerial/BreAerialConfig';
import { FormHorizontal } from '~/components/form/layout';
import ValibotFieldInput from '~/components/valibot/ValibotFieldInput';
import { useValibotFieldSingleValue } from '~/components/valibot/ValibotForm';

export default function BreAerialSubmit(): ReactElement {
  const type = useValibotFieldSingleValue<BreAerialType>('type');

  return (
    <FormGroup>
      {bre_is_aerial_video(type) && (
        <FormHorizontal label="Self Edited Video">
          <ValibotFieldCheckbox id="self_edited" name="self_edited" />
        </FormHorizontal>
      )}
      {bre_is_aerial_photo(type) && (
        <FormHorizontal name="ai_edit" label="Submit Photos for AI Editing">
          <ValibotFieldCheckbox name="ai_edit" />
        </FormHorizontal>
      )}
      {bre_is_aerial_photo(type) && (
        <FormHorizontal label="Photo Editing Credits">
          <ValibotFieldInput name="editing_credits" type="number" />
        </FormHorizontal>
      )}
    </FormGroup>
  );
}
